// `voice.design`: a voice from a description (G7-voice-design).
// Live's Create Voice, "Design a voice"; its form builds these.
import { VoiceDesignQuote, VoiceDesignRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"voice.design"> = {
  type: "voice.design",
  label: "Voice design",
  source: "form",
  pair: "voice.design",
  fields: (draft) => commonFields(draft),
  request: VoiceDesignRequest,
  quote: VoiceDesignQuote,
};
